const getEnvironment = () => {
  return { ...process.env };
}

export default getEnvironment;